(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function slideStep(track) {
    var slide = track.querySelector('.mm-top__slide');
    if (!slide) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function bind(root) {
    if (!root || root.dataset.mmTopBound === 'true') return;
    root.dataset.mmTopBound = 'true';

    var track = root.querySelector('.mm-top__track');
    var viewport = root.querySelector('[data-mm-top-track]');
    if (!track || !viewport) return;

    var index = 0;
    var slides = track.querySelectorAll('.mm-top__slide');
    var startX = 0;
    var startLeft = 0;
    var dragging = false;
    var didDrag = false;

    function maxIndex() {
      if (!isMobile()) return 0;
      // show ~1.2 cards; allow scrolling through all
      return Math.max(0, slides.length - 1);
    }

    function goTo(next) {
      if (!isMobile()) {
        track.style.transform = 'none';
        index = 0;
        return;
      }
      index = Math.max(0, Math.min(next, maxIndex()));
      track.style.transform = 'translateX(' + -(index * slideStep(track)) + 'px)';
    }

    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (!isMobile()) return;
        dragging = true;
        didDrag = false;
        startX = e.changedTouches[0].clientX;
        startLeft = index * slideStep(track);
        track.style.transition = 'none';
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (e) {
        if (!dragging || !isMobile()) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 8) didDrag = true;
        track.style.transform = 'translateX(' + -(startLeft - dx) + 'px)';
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function (e) {
        if (!dragging || !isMobile()) return;
        dragging = false;
        track.style.transition = '';
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          goTo(index + (dx < 0 ? 1 : -1));
        } else {
          goTo(index);
        }
      },
      { passive: true }
    );

    viewport.addEventListener(
      'click',
      function (e) {
        if (!didDrag) return;
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      },
      true
    );

    window.addEventListener('resize', function () {
      goTo(0);
    });

    goTo(0);
  }

  function initAll() {
    document.querySelectorAll('[data-mm-top]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-mm-top]');
    if (root) {
      delete root.dataset.mmTopBound;
      bind(root);
    }
  });
})();
